import React from "react";
import { connect } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";
import { push } from "react-router-redux";
import { bindActionCreators } from "redux";

import { clearAlert, clearState } from "Skelet/src/modules/fetch.action.js";
import AlertBar from "Skelet/src/components/AlertBar.js";
import Start from "./StartPages/Start.js";
import PageNotFound from "Skelet/src/components/PageNotFound.js";
import Overview from "./Overview.js";
import Body from "./Body.js";
import Diary from "./Diary.js";
import ViewUsers from "./ViewUsers.js";
import Settings from "./Settings.js";
import Profile from "./Profile.js";
import Terms from "./StartPages/Terms.js";
import Privacy from "./StartPages/Privacy.js";
import CoreRoute from "./route-containers/CoreRoute.js";
import StartRoute from "./route-containers/StartRoute.js";

class App extends React.Component {
  componentDidUpdate(prevProps) {
    const isLoggingOut = prevProps.session_token && !this.props.session_token;
    const isLoggingIn = !prevProps.session_token && this.props.session_token;

    if (isLoggingIn) {
      if (this.props.redirectUrl) {
        this.props.push(this.props.redirectUrl);
      } else {
        this.props.push("/");
      }
    } else if (isLoggingOut) {
      this.props.clearState();
      this.props.push("/start");
    }
  }

  render() {
    return (
      <div id="main">
        <Switch>
          <StartRoute exact path="/start" component={Start} />

          <StartRoute exact path="/privacy" component={Privacy} />

          <StartRoute exact path="/terms" component={Terms} />

          <CoreRoute exact path="/" component={Overview} />

          <CoreRoute exact path="/lichaam" component={Body} />

          <CoreRoute exact path="/dagboek" component={Diary} />

          {this.props.is_admin && (
            <CoreRoute exact path="/beheer-gebruikers" component={ViewUsers} />
          )}

          <CoreRoute exact path="/instellingen" component={Settings} />

          <CoreRoute exact path="/profiel" component={Profile} />

          <Route path="*" component={PageNotFound} />
        </Switch>
        <AlertBar alert={this.props.alert} clearAlert={this.props.clearAlert} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  let session_token = null,
    account_data = null;
  if (
    state.apiData["login"] !== undefined &&
    (state.apiData["login"]["data"]["token"] !== undefined ||
      state.apiData["login"]["data"]["token"] === null)
  ) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  if (
    state.apiData["login"] !== undefined &&
    state.apiData["login"]["data"]["token"] !== undefined
  ) {
    account_data = state.apiData["login"]["data"];
  }
  return {
    state_router: state.router, // needed for redirect after login
    session_token: session_token,
    account_data: account_data,
    is_admin:
      account_data && account_data.email === "hi@peter.plus" ? true : false,
    redirectUrl: state.apiData.redirectUrl,
    alert: state.apiData.alert,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      push,
      clearAlert,
      clearState,
    },
    dispatch,
  );
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/containers/_app.js